import { PERMISSIONS } from '@core/constants/permissions.constants';
import { ReportConfig } from './sparepart-report.config';

export const PM_COMPLIANCE_REPORT_CONFIG: ReportConfig = {
  id: 'pm-compliance',
  title: 'PM Compliance Report',
  permissions: {
    view: PERMISSIONS.GSE.REPORTS.PM_COMPLIANCE.VIEW,
    export: PERMISSIONS.GSE.REPORTS.PM_COMPLIANCE.EXPORT,
  },
  filters: [
    {
      type: 'text',
      field: 'search',
      label: 'Search',
      placeholder: 'Search'
    },
    {
      type: 'date-range',
      field: 'dateRange',
      label: 'Date Range',
      placeholder: 'Date range'
    },
    {
      type: 'dropdown',
      field: 'equipment',
      label: 'Equipment',
      placeholder: 'Equipment',
    },
  ],

  columns: [
    {
      field: 'equipmentName',
      header: 'Equipment Name',
      type: 'text',
      width: '28%',
    },
    {
      field: 'plannedPM',
      header: 'Planned Preventive Maintenance',
      type: 'number',
      width: '22%',
    },
    {
      field: 'completedPM',
      header: 'Completed Preventive Maintenance',
      type: 'number',
      width: '22%',
    },
    {
      field: 'pmCompliancePercentage',
      header: 'PM Compliance %',
      type: 'number',
      width: '28%',
    },
  ],
};
